import { useRef, useEffect } from 'react'
import { Search } from '@stratascratch/icons'
import SearchDialog from './SearchDialog'

export default function SearchButton() {
  const dialogRef = useRef<HTMLDialogElement>(null)

  const toggleSearch = () => {
    if (dialogRef.current?.open) {
      dialogRef.current.close()
    } else {
      dialogRef.current?.showModal()
    }
  }

  const isMac =
    typeof navigator !== 'undefined' && navigator?.platform.startsWith('Mac')

  useEffect(() => {
    const controller = new AbortController()
    window.addEventListener(
      'keydown',
      (e) => {
        const modifier = isMac ? e.metaKey : e.ctrlKey
        const keys = [e.key === '/', modifier && e.key === 'k']
        if (keys.some((k) => k)) {
          e.preventDefault()
          toggleSearch()
        }
      },
      { signal: controller.signal },
    )

    return () => controller.abort()
  }, [])

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          dialogRef.current?.showModal()
        }}
        className="bg-(--bg-color-secondary) text-(--text-color-300) flex h-8 w-48 cursor-pointer items-center gap-1 rounded-md px-2 text-sm transition-colors hover:bg-neutral-400"
      >
        <Search /> Search{' '}
        <kbd className="border-(--color-border) hover:bg-(--bg-color-secondary) ms-auto rounded-sm border bg-white px-1 py-0.5 font-sans text-xs text-black">
          {isMac ? '⌘' : 'Ctrl-'}K
        </kbd>
      </button>
      <SearchDialog ref={dialogRef} />
    </div>
  )
}
